export default "__VITE_ASSET__BfOfVCIX__"